import { useState } from "react"
import arrowLeftIcon from "./images/arrow-left.svg"
import presetMark from "./images/preset-mark.svg"
import Button from "components/ui/Button"
import SignUpButton from "components/ui/SignUpButton"
import { CONTACT_URL } from "constants/urls"

function NavMobile({ items, trackSignupButtonClick, onContactSalesClick }) {
  const [activeItem, setActiveItem] = useState(null)

  const navItems = activeItem ? activeItem.items : items

  function BackButton() {
    return (
      <button
        className="absolute top-0 left-0 inline-flex items-center p-4 text-base font-medium text-black"
        onClick={() => setActiveItem(null)}
        type="button"
      >
        <img className="mr-1 h-3" src={arrowLeftIcon} alt="Arrow left" />
        Main Menu
      </button>
    )
  }

  function Item(item) {
    const classNames = "text-2xl font-bold text-black hover:text-lush"
    const { label, path, items: subItems } = item
    const isContactSales = path === CONTACT_URL

    if (subItems && subItems.length > 0) {
      return (
        <Button className={classNames} onClick={() => setActiveItem(item)}>
          {label}
        </Button>
      )
    }

    // Handle Contact Sales specially - open modal instead of navigating
    if (isContactSales && onContactSalesClick) {
      return (
        <Button className={classNames} onClick={onContactSalesClick}>
          {label}
        </Button>
      )
    }

    return (
      <Button className={classNames} href={path}>
        {label}
      </Button>
    )
  }

  return (
    <div className="nav-mobile">
      <img
        className="absolute bottom-0 left-0"
        src={presetMark}
        alt="Preset mark"
      />
      {activeItem && <BackButton />}
      <ul className="relative z-30 flex flex-col items-center space-y-6">
        {navItems.map((props) => (
          <Item key={props.id || props.text} {...props} />
        ))}
        {!activeItem && (
          <li>
            <SignUpButton
              size="small"
              trackClick={`${trackSignupButtonClick} (mobile)`}
            >
              Try for Free
            </SignUpButton>
          </li>
        )}
      </ul>
    </div>
  )
}

export default NavMobile
